import { useAuthStore } from '../store/authStore'

export const useAuth = () => {
  const user             = useAuthStore((s) => s.user)
  const session          = useAuthStore((s) => s.session)
  const household        = useAuthStore((s) => s.household)
  const households       = useAuthStore((s) => s.households)
  const isLoading        = useAuthStore((s) => s.isLoading)
  const needsOnboarding  = useAuthStore((s) => s.needsOnboarding)
  const signOut          = useAuthStore((s) => s.signOut)
  const switchHousehold  = useAuthStore((s) => s.switchHousehold)
  const refreshHouseholds = useAuthStore((s) => s.refreshHouseholds)

  return {
    user,
    session,
    household,
    households,
    isLoading,
    needsOnboarding,
    signOut,
    switchHousehold,
    refreshHouseholds,
    isAuthed:   !!session,
    isAdmin:    household?.userRole === 'admin',
    isLimited:  household?.userRole === 'limited',
  }
}
